/* int-l4-region-stock.js: moved from snippets/int-region-stock.liquid (pdp-html-weight lever 4 batch 2, 2026-11-02). The Liquid values arrive in the JSON island #int-rs-data. Do not edit here without the source note. */
(function () {
  'use strict';
  var D = JSON.parse(document.getElementById('int-rs-data').textContent);
  var ids = D.ids;
  if (!ids.length) return;
  var oos = Object.create(null);
  for (var i = 0; i < ids.length; i++) oos[ids[i]] = true;
  window.INT_REGION_OOS = oos;             /* read by klaviyo-bis-fix */
  window.INT_REGION_OOS_NOTIFY = true;     /* false = disabled ATC instead of notify button */

  function productJson() {
    try {
      var el = document.querySelector('[data-product-json]');
      return el ? JSON.parse(el.textContent) : null;
    } catch (e) { return null; }
  }

  function selectedValues() {
    var map = {};
    document.querySelectorAll('[data-swapper-wrapper]').forEach(function (w) {
      var pos = w.getAttribute('data-option-position');
      if (!pos) return;
      var checked = w.querySelector('input[type="radio"]:checked');
      if (checked) { map[pos] = checked.value; return; }
      var hidden = w.querySelector('input[data-popout-input]');
      if (hidden) map[pos] = hidden.value;
    });
    return map;
  }

  /* Patch the page's product JSON so every consumer (klaviyo-bis-fix, theme
     logic) sees region-OOS variants as unavailable — same path as sold-out. */
  function mutateJson() {
    if (window.INT_REGION_OOS_NOTIFY === false) return;
    var el = document.querySelector('[data-product-json]');
    if (!el) return;
    try {
      var p = JSON.parse(el.textContent);
      var changed = false;
      for (var i = 0; i < p.variants.length; i++) {
        if (oos[p.variants[i].id] && p.variants[i].available) {
          p.variants[i].available = false;
          changed = true;
        }
      }
      if (changed) {
        el.textContent = JSON.stringify(p);
        var form = document.querySelector('form[data-product-form]');
        if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } catch (e) {}
  }

  function variantFor(values, product) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i], match = true;
      for (var pos in values) {
        if (v['option' + pos] !== values[pos]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function mark() {
    var product = productJson();
    if (!product) return;
    var current = selectedValues();
    document.querySelectorAll('[data-swapper-wrapper]').forEach(function (w) {
      var pos = w.getAttribute('data-option-position');
      if (!pos) return;
      w.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var probe = {};
        for (var k in current) probe[k] = current[k];
        probe[pos] = input.value;
        var v = variantFor(probe, product);
        var flag = !!(v && oos[v.id]);
        var host = input.closest('.radio__button, radio-swatch');
        if (host) host.classList.toggle('int-region-oos', flag);
      });
    });
  }

  /* ---------- regional notify-me modal (worker-powered, per region) ------ */
  var NOTIFY_URL = 'https://intention-stock-sync.nils-8f9.workers.dev/notify';
  var REGION = D.region;
  var modal = null;

  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'int-bis-overlay';
    modal.innerHTML =
      '<div class="int-bis-box" role="dialog" aria-modal="true" aria-label="' + D.s0255 + '">' +
        '<button type="button" class="int-bis-close" aria-label="Close">&times;</button>' +
        '<p class="int-bis-title">' + D.s0255 + '</p>' +
        '<p class="int-bis-sub"></p>' +
        '<form class="int-bis-form">' +
          '<input type="email" required placeholder="' + D.s0269 + '" class="int-bis-email" autocomplete="email">' +
          '<button type="submit" class="int-bis-submit">' + D.s0271 + '</button>' +
        '</form>' +
        '<p class="int-bis-done" hidden>' + D.s0270 + '</p>' +
      '</div>';
    var style = document.createElement('style');
    style.textContent =
      '#int-bis-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:20px}' +
      '#int-bis-overlay[hidden]{display:none}' +
      '.int-bis-box{position:relative;background:#fff;max-width:420px;width:100%;padding:36px 32px;text-align:center;font-family:inherit}' +
      '.int-bis-close{position:absolute;top:8px;right:14px;background:none;border:none;font-size:26px;line-height:1;cursor:pointer;color:#575757}' +
      '.int-bis-title{margin:0 0 6px;font-size:16px;letter-spacing:.02em}' +
      '.int-bis-sub{margin:0 0 18px;font-size:13px;color:#777}' +
      '.int-bis-form{display:flex;flex-direction:column;gap:10px}' +
      '.int-bis-form[hidden]{display:none}' +
      '.int-bis-email{padding:12px 14px;border:1px solid #ccc;font-size:14px;width:100%;box-sizing:border-box}' +
      '.int-bis-submit{padding:13px 22px;border:1px solid #575757;background:transparent;color:#575757;font-size:14px;cursor:pointer}' +
      '.int-bis-submit:hover{background:rgba(0,0,0,.04)}' +
      '.int-bis-done{margin:14px 0 0;font-size:14px}';
    document.head.appendChild(style);
    document.body.appendChild(modal);
    modal.hidden = true;
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.hidden = true; });
    modal.querySelector('.int-bis-close').addEventListener('click', function () { modal.hidden = true; });
    modal.querySelector('.int-bis-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = modal.querySelector('.int-bis-email').value;
      var payload = JSON.stringify({
        email: email,
        variantId: modal.dataset.variantId,
        region: REGION,
        product: modal.dataset.product,
        variant: modal.dataset.variant,
        url: location.href.split('?')[0],
      });
      fetch(NOTIFY_URL, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: payload })
        .catch(function () {});
      modal.querySelector('.int-bis-form').hidden = true;
      modal.querySelector('.int-bis-done').hidden = false;
    });
    return modal;
  }

  function openModal(variantId) {
    var p = productJson();
    var v = null;
    if (p) for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id == variantId) { v = p.variants[i]; break; }
    var m = buildModal();
    m.dataset.variantId = String(variantId);
    m.dataset.product = (p && p.title) || '';
    m.dataset.variant = (v && v.title) || '';
    m.querySelector('.int-bis-sub').textContent = ((p && p.title) || '') + (v ? ' · ' + v.title : '');
    m.querySelector('.int-bis-form').hidden = false;
    m.querySelector('.int-bis-done').hidden = true;
    m.hidden = false;
    setTimeout(function () { var inp = m.querySelector('.int-bis-email'); if (inp) inp.focus(); }, 50);
  }

  function currentVariantId() {
    var el = document.querySelector('input[name="id"]');
    return el ? parseInt(el.value, 10) : null;
  }

  /* Region-OOS current variant: the notify button opens OUR modal
     (Klaviyo's own BIS trigger does not exist for globally-in-stock items). */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('#bis-proxy-btn');
    if (!btn) return;
    var id = currentVariantId();
    if (id && oos[id]) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openModal(id);
    }
  }, true);

  /* Clicking a crossed-out (region-OOS) size/colour opens the modal too. */
  document.addEventListener('click', function (e) {
    var chip = e.target && e.target.closest && e.target.closest('.int-region-oos');
    if (!chip) return;
    var input = chip.querySelector('input[type="radio"]');
    if (!input) return;
    var p = productJson();
    if (!p) return;
    var w = chip.closest('[data-swapper-wrapper]');
    var pos = w && w.getAttribute('data-option-position');
    if (!pos) return;
    var probe = selectedValues();
    probe[pos] = input.value;
    var v = variantFor(probe, p);
    if (v && oos[v.id]) setTimeout(function () { openModal(v.id); }, 250);
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-swapper-wrapper] input, [data-popout-input]')) {
      setTimeout(mark, 50);
      setTimeout(mark, 300);
    }
  });
  ['variant:change', 'theme:variant:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(mark, 50); }, true);
  });

  function init() { mutateJson(); mark(); }
  /* The DOMContentLoaded listener is the inline stub next to the island (registered at the same moment as before),
     so init still runs in the same order among the page's other DOMContentLoaded work. */
  window.__intRsInit = init;
  if (window.__intRsDcl) init();
})();
